/**
 * Replace the leading +/- sign of a formatted model value with a
 * designer-chosen glyph (e.g. ▲ for positive, ▼ for negative). Opt-in per
 * quantity. Zero is neutral and returned unchanged, as is any non-numeric
 * placeholder ("Loading..."). If the chosen glyph is blank we leave the value
 * untouched so the sign is never silently dropped.
 *
 * The currency symbol / digits are preserved — only a single leading sign is
 * consumed (ASCII hyphen-minus, unicode minus U+2212, or a leading "+").
 *
 * Dependency-free so it can be unit-tested without the tiptap node view.
 */
export function applySignGlyph(
    formatted: string,
    numericalValue: unknown,
    enabled: boolean,
    positiveGlyph: string,
    negativeGlyph: string,
): string {
    if (
        !enabled ||
        typeof numericalValue !== "number" ||
        Number.isNaN(numericalValue) ||
        numericalValue === 0
    ) {
        return formatted;
    }

    const glyph = numericalValue < 0 ? negativeGlyph : positiveGlyph;
    if (!glyph) return formatted;

    // Strip a single leading sign, keeping any surrounding currency symbol and
    // the original leading whitespace intact.
    const stripped = formatted.replace(/^(\s*)[-+−]\s*/, "$1");
    return `${glyph}${stripped}`;
}
